<template>
  <div class="container has-text-centered">
    <h1 class="title custom-text-dark custom-heading">
      MoodMelody
    </h1>
    <h2 class="subtitle custom-text-dark custom-regular-text">
      <span >The automatic chord progression generator</span>
    </h2>
  </div>
</template>

<script>
export default {
  name: "Heading",
};
</script>

<style>
.custom-text-dark {
  color: #3D3D3D;;
  font-family: "Montserrat Alternates";
}
.custom-heading {
  font-weight: 900;
}
.custom-regular-text {
  font-weight: 400;
}
.notif{
  color: #C92C6D;
}
</style>
